import { render, staticRenderFns } from "./withdrawSetting.vue?vue&type=template&id=456b3f59&"
import script from "./withdrawSetting.vue?vue&type=script&lang=js&"
export * from "./withdrawSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports